module.exports = __webpack_public_path__ + "img/city-animated_atlas_.c9690956.png";